import {
  BatchCollectionMgmtRemovalListConditionListItem,
  BatchCollectionMgmtRemovalListConditionListItemFromJSON
} from '@/api/models/batch/BatchCollectionMgmtRemovalListConditionListItem'

export interface BatchCollectionMgmtRemovalListPageLoadResult {
  items: BatchCollectionMgmtRemovalListConditionListItem
}

export function BatchCollectionMgmtRemovalListPageLoadResultFromJSON(
  json: any
): BatchCollectionMgmtRemovalListPageLoadResult {
  return {
    items: BatchCollectionMgmtRemovalListConditionListItemFromJSON(json)
  }
}
